import React, { useEffect, useRef, useState } from 'react';
import '../../styles/variables.css';
import './UserAvatar.css';
import userImage from '../../assets/user.png';
import UserSettingsPopup from './UserSettingsPopup';
import { useAppSelector, useAppDispatch } from '../../store/hooks/hooks';
import { getUserAvatarUrl } from '../../store/slices/userSlice';
import { setUserSettingsPopupIsOpen, getUserSettingsPopupIsOpen } from '../../store/slices/appSlice';


const UserAvatar = () => {
	const avatarUrl = useAppSelector(getUserAvatarUrl);
	const isPopupOpen = useAppSelector(getUserSettingsPopupIsOpen);

	const avatarRef = useRef<HTMLDivElement | null>(null);

	const dispatch = useAppDispatch();
	const handleAvatarClick = (event: React.MouseEvent<HTMLDivElement>) => {
		event.stopPropagation();
		dispatch(setUserSettingsPopupIsOpen(!isPopupOpen));
	};

	return (
		<div
			ref={avatarRef}
			className="user-avatar"
			onClick={handleAvatarClick}
		>
			<img
				className="shadow"
				src={avatarUrl || userImage}
				onError={(event) => { event.currentTarget.src = userImage; }}
				alt="User avatar"
			/>

			{isPopupOpen && <UserSettingsPopup />}
		</div>
	)
}

export default UserAvatar
